/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnlinePaymentDetailsDto } from '../../models/online-payment-details-dto';

export interface GetPaymentDetailsOnline$Params {
  id: number;
}

export function getPaymentDetailsOnline(http: HttpClient, rootUrl: string, params: GetPaymentDetailsOnline$Params, context?: HttpContext): Observable<StrictHttpResponse<OnlinePaymentDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, getPaymentDetailsOnline.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OnlinePaymentDetailsDto>;
    })
  );
}

getPaymentDetailsOnline.PATH = '/api/v1/order/{id}/online-payment-details';
